export const TypeAngles = {
    "Tipo A1": 105,
    "Tipo A3": 120,
    "Tipo B": 70,
    "Tipo B-2": 120,
    "Tipo E": 40,
    "Tipo I": 120,
    "Tipo T2.1": 62,
    "Tipo T2.2": 120,
    "Tipo TB": 52,
    "Tipo A2": 138,
    "Tipo B1": 120,
    "Tipo B2": 130,
    "Tipo D1": 20,
    "Tipo E1": 50,
    "Tipo E2": 50,
    "Tipo F1": 40,
    "Tipo G": 80,
    "Tipo H1": 120,
    "Tipo H2": 130,

    "Tipo D1B": 138,

    "Tipo E1B": 60,
    "Tipo E1A": 60,

    "Tipo B2A": 60,
    "Tipo B2B": 60,

    "Tipo D2B": 120,
    "Tipo D2C": 120,
    "Tipo D2D": 120,
}
